/** Sinal sem dados pessoais: a Sala informa ao host que precisa de uma segunda etapa. */
export type AcaoMfa = 'inscrever' | 'verificar';
export interface PedidoMfa { acao: AcaoMfa; caminho: string }
let pedido: PedidoMfa | null = null;
let escopo = '';
const ouvintes = new Set<() => void>();

export const capturarEscopoMfa = () => escopo;
export function definirEscopoMfa(proximo: string): void {
  if (escopo === proximo) return;
  escopo = proximo;
  limparPedidoMfa();
}
export function notificarMfa(caminho: string, status: number, code: string, details?: Record<string, unknown>, escopoRequisicao = escopo): void {
  if (escopoRequisicao !== escopo) return;
  if (status !== 403 || code !== 'mfa_exigido' || !/^\/api\/v1\/sala360(?:\/|\?|$)/.test(caminho)) return;
  const acao = details?.acao === 'inscrever' ? 'inscrever' : 'verificar';
  if (pedido?.acao === acao) return;
  pedido = { acao, caminho };
  for (const ouvir of ouvintes) ouvir();
}
export function limparPedidoMfa(): void {
  if (!pedido) return;
  pedido = null;
  for (const ouvir of ouvintes) ouvir();
}
export const lerPedidoMfa = () => pedido;
export function observarMfa(ouvir: () => void): () => void {
  ouvintes.add(ouvir);
  return () => { ouvintes.delete(ouvir); };
}
